import React, { SVGProps } from 'react'
import withIcon from './hoc/withIcon'

const MoreVertical: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7.42874 7.9998C7.42874 8.3154 7.68457 8.57123 8.00017 8.57123C8.31576 8.57123 8.57159 8.3154 8.57159 7.9998C8.57159 7.68421 8.31576 7.42838 8.00017 7.42838C7.68457 7.42838 7.42874 7.68421 7.42874 7.9998Z" />
      <path d="M7.42874 11.9998C7.42874 12.3154 7.68457 12.5712 8.00017 12.5712C8.31576 12.5712 8.57159 12.3154 8.57159 11.9998C8.57159 11.6842 8.31576 11.4284 8.00017 11.4284C7.68457 11.4284 7.42874 11.6842 7.42874 11.9998Z" />
      <path d="M7.42874 3.9998C7.42874 4.3154 7.68457 4.57123 8.00017 4.57123C8.31576 4.57123 8.57159 4.3154 8.57159 3.9998C8.57159 3.68421 8.31576 3.42838 8.00017 3.42838C7.68457 3.42838 7.42874 3.68421 7.42874 3.9998Z" />
      <path
        d="M7.42874 7.9998C7.42874 8.3154 7.68457 8.57123 8.00017 8.57123C8.31576 8.57123 8.57159 8.3154 8.57159 7.9998C8.57159 7.68421 8.31576 7.42838 8.00017 7.42838C7.68457 7.42838 7.42874 7.68421 7.42874 7.9998Z"
        stroke="#00112F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.42874 11.9998C7.42874 12.3154 7.68457 12.5712 8.00017 12.5712C8.31576 12.5712 8.57159 12.3154 8.57159 11.9998C8.57159 11.6842 8.31576 11.4284 8.00017 11.4284C7.68457 11.4284 7.42874 11.6842 7.42874 11.9998Z"
        stroke="#00112F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.42874 3.9998C7.42874 4.3154 7.68457 4.57123 8.00017 4.57123C8.31576 4.57123 8.57159 4.3154 8.57159 3.9998C8.57159 3.68421 8.31576 3.42838 8.00017 3.42838C7.68457 3.42838 7.42874 3.68421 7.42874 3.9998Z"
        stroke="#00112F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

MoreVertical.displayName = 'MoreVertical'

export default withIcon(MoreVertical)
